<template>
  <div class="modal fade" id="reset-pwd-success" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document" aria-hidden="true">
      <div class="modal-content">
        <div class="modal-header">
          <span class="close" data-dismiss="modal" aria-label="Close">
            <svg class="icon" aria-label="true">
              <use xlink:href="#icon-close" />
            </svg>
          </span>
        </div>
        <div class="modal-body">
          <p>
            <img src="/static/img/resetPwd/success.png" alt="重置密码成功" />
          </p>
          <p class="describe">{{ $t('successInfo') }}</p>
        </div>
        <div class="modal-footer">
          <button data-dismiss="modal" aria-label="Close">{{ $t('ok') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import locales from './lang';
import { SET_USER_INFO } from '../../store/mutation-types';

export default {
  name: 'success-notice-component',
  props: ['show', 'loginData'],
  locales,
  mounted() {
    let _this = this;
    $('#reset-pwd-success').on('hidden.bs.modal', function () {
      _this.login();
    });
  },
  watch: {
    show() {
      if (this.show) {
        $('#reset-pwd-success').modal('show');
      }
    }
  },
  computed: {
    loginUrl() {
      if (this.loginData.email) {
        return 'api/login';
      } else {
        return 'api/phone-login';
      }
    }
  },
  methods: {
    login() {
      this.$http.post(this.loginUrl, this.loginData).then(response => {
        switch (response.data.code) {
          case 0: {
            window.localStorage.setItem('token', response.data.data.access_token);
            this.$store.commit(SET_USER_INFO, response.data.data);
            this.$router.push('/dashboard');
            break;
          }
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../assets/scss/variables';
@import '../../assets/scss/reset-modal';
@import '../../assets/scss/mixins/button';
* {
  margin: 0;
  padding: 0;
}

.modal-dialog {
  @include modal-dialog($height: 2.9rem, $phone-height: 3.2rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.6rem) 0 0 -45% !important;
    }
}

.modal-content {
  padding: 0.2rem;
  text-align: center;
}

.modal-header {
  min-height: 0.2rem;
}

.modal-body {
  img {
    max-width: 0.5rem;
    margin-bottom: 0.2rem;
  }
  p.describe {
    line-height: 0.3rem;
    font-size: 0.24rem;
    color: #333333;
    letter-spacing: 0;
    margin-bottom: 0.6rem;
  }
}

.modal-footer {
  text-align: center;
  button {
    @include modal-button();
  }
}
</style>



// WEBPACK FOOTER //
// SuccessNotice.vue?334a6f4d